import React, { ChangeEvent, useEffect, useState } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useDispatch } from 'react-redux';
import {
  DialogHeading,
  DialogMessage,
  SummaryCalculationsDialogActions,
} from 'spw-components/dialogs/total-program/styles';
import { SPWSaveButton } from 'spw-shared/globalComponents/buttons';
import { SPWBaseTextField, SPWCancelButton } from 'spw-shared/globalComponents';
import { setRsfLoadFactor as setRsfLoadFactorAction } from 'spw-redux/modules/calculators/actions';
import { convertToTwoDec } from 'spw-components/growth-calculator/utils';
import { colors } from 'spw-theme';
import { SummaryCalculator } from '../../models/ProgramSummaryCalculator';

interface DepartmentsRsfFactorModalProps {
  showDialog: boolean;
  setShowDialog?: (showDialog: boolean) => void;
  setEditFactor: (editFactor: string) => void;
  summaryCalculator: SummaryCalculator;
}

const useStyles = makeStyles({
  marginVertical24: { marginTop: 24, marginBottom: 24 },
});

const DepartmentsRsfFactorModal: React.FC<DepartmentsRsfFactorModalProps> = ({
  showDialog,
  setShowDialog,
  setEditFactor,
  summaryCalculator,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { rsfLoadFactorPercentage: defaultRsfLoadFactor } = summaryCalculator;

  const [rsfLoadFactor, setRsfLoadFactor] = useState(
    defaultRsfLoadFactor ? defaultRsfLoadFactor.toFixed(2) : '0.00'
  );

  useEffect(() => {
    setRsfLoadFactor(defaultRsfLoadFactor?.toFixed(2) || '0.00');
  }, [defaultRsfLoadFactor]);

  const onClose = () => {
    setEditFactor('');
    setShowDialog(false);
  };

  const onBlur = () => {
    if (rsfLoadFactor === '') {
      setRsfLoadFactor('0.00');
    } else if (parseFloat(rsfLoadFactor) > 75.0) {
      setRsfLoadFactor('75.00');
    }
  };

  const onSave = () => {
    dispatch(
      setRsfLoadFactorAction(
        parseFloat((parseFloat(rsfLoadFactor) / 100).toFixed(4))
      )
    );
    onClose();
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    setRsfLoadFactor(convertToTwoDec(inputValue));
  };

  return (
    <Dialog open={showDialog} onClose={onClose} disableScrollLock>
      <DialogContent>
        <DialogHeading style={{ marginBottom: 24, marginTop: 0 }}>
          Rentable Load Factor %
        </DialogHeading>

        <DialogMessage>
          <div>
            <b>CAUTION</b>
          </div>
          Rentable Load Factor is applied to all Department scenarios in this
          project. Changing it here will update all Department scenarios in this
          project.
        </DialogMessage>

        <SPWBaseTextField
          className={classes.marginVertical24}
          fullWidth
          onChange={handleInputChange}
          data-testid="rsf_load_factor_input"
          value={rsfLoadFactor}
          label="Rentable Load Factor %"
          style={{ width: '100%' }}
          onBlur={onBlur}
        />
        <SummaryCalculationsDialogActions>
          <SPWSaveButton onClick={onSave} />
          <SPWCancelButton onClick={onClose} customColor={colors.black} />
        </SummaryCalculationsDialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default DepartmentsRsfFactorModal;
